// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconEducator from '@/components/icons/educator.vue'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStar from '@/components/icons/star.vue'
import BackButton from '@/components/BackButton.vue'
import Globals from '@/assets/scripts/global-functions.js'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: 'SelectAPackage',
    components: {
        IconEducator,
        IconCheck,
        IconBase,
        IconForwardBack,
        IconArrowBack,
        IconStar,
        Globals,
        BackButton,
        NextButton
    },
    data: () => ({
        package_code: "", 
        package_id: "",
        package_id_element: "",
    }),
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            if(this.package_id.length > 0) {
                _isvalid = true;
            }
            return _isvalid;
        }
    },
    methods: {
        SelectThisItem(_eid, _package, _policy_id) {
            /*======================================
            
            function:  
            ► calls function RemoveClassFrom
            ► add selected state to the clicked package
            ► get the name on selected package
            ► get the policy id on the selected package

            ======================================*/
            
            this.package_id = _policy_id;
            this.package_code = _package;
            this.package_id_element = _eid;
            var a = document.getElementById(_eid);
            if(a.className.indexOf("selected") < 0) {
                Globals.RemoveClassFrom("selector-item", "selected");
                a.classList.add("selected");
            }
            //this.$parent.EnableNextButton();

             /*======================================
            Note:
            this is how you access parent element:
            this.$parent.TestVariable = "Woah!!!"

            ======================================*/
        },
        Next() {
            if(this.package_code != "") {
                this.$parent.EducatorInsuranceProcess.package_code = this.package_code;
                this.$parent.EducatorInsuranceProcess.package_id = this.package_id;
                this.$parent.EducatorInsuranceProcess.package_id_element = this.package_id_element;
                this.$parent.EducatorNextStep(0,"AboutYou");
            }
        }, 
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.package_id_element) {
                const _package_id_element = this.$parent.EducatorInsuranceProcess.package_id_element;
                document.getElementById(_package_id_element).classList.add("selected");
                this.package_code = this.$parent.EducatorInsuranceProcess.package_code;
                this.package_id = this.$parent.EducatorInsuranceProcess.package_id;
                this.package_id_element = this.$parent.EducatorInsuranceProcess.package_id_element;
            }
        }
    },
    mounted(){
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
        this.$parent.CheckWindowPathName();
        this.$parent.hideProgressBar = true;
    }
}